/*
 * LanguageSelect
 */
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@emr/react-ui"
import { useTranslation } from "react-i18next"
import { LocaleEnum } from "../intl.constants"

const localeLabels: Record<LocaleEnum, string> = {
	[LocaleEnum.enUS]: "English",
	[LocaleEnum.frCA]: "Français",
}

export function LanguageSelect() {
	const { i18n } = useTranslation()

	return (
		<Select
			value={i18n.language}
			onValueChange={(value) => i18n.changeLanguage(value)}
		>
			<SelectTrigger className={"w-[100px]"}>
				<SelectValue />
			</SelectTrigger>
			<SelectContent>
				{Object.entries(localeLabels).map(([locale, label]) => (
					<SelectItem key={locale} value={locale}>
						{label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	)
}
